import { FC } from 'react';
import { tailwindOverride } from '@getsynapse/design-system';
import { IconButton } from '@getsynapse/design-system';
import collapseIcon from 'assets/icons/collapse.svg';
import expandIcon from 'assets/icons/expand.svg';
import logoText from 'assets/icons/logo-text.svg';
import cognotaLogo from 'assets/icons/logo-icon.svg';

interface HeaderProps {
  isExpanded: boolean;
  isHovered: boolean;
  onToggleExpanded: () => void;
}

const Header: FC<HeaderProps> = ({
  isExpanded,
  isHovered,
  onToggleExpanded,
}) => {
  return (
    <div className={tailwindOverride('flex mb-4 justify-between items-center')}>
      <div className='flex flex-row h-8'>
        <div className='relative flex' data-testid='logo-section'>
          <img
            src={cognotaLogo}
            className={tailwindOverride('h-6 w-3 my-auto', {
              hidden: !isExpanded && isHovered,
            })}
            style={{ marginLeft: '14px' }}
            alt='logo'
            onClick={() => {
              if (!isExpanded) {
                onToggleExpanded();
              }
            }}
          />

          {!isExpanded && isHovered ? (
            <IconButton
              description='expand sidebar'
              src={expandIcon}
              className={tailwindOverride(
                'absolute top-0 left-0 my-auto flex h-full',
                {
                  'opacity-100': !isHovered,
                }
              )}
              iconClassname={tailwindOverride(
                'items-center justify-center bg-primary-darker bg-opacity-50 rounded-sm text-lg text-off-white my-auto'
              )}
              hasASize={false}
              onClick={onToggleExpanded}
              aria-label='expand sidebar'
              style={{ marginLeft: '11px' }}
            />
          ) : null}
        </div>
        <img
          src={logoText}
          alt='Cognota'
          className={tailwindOverride('overflow-hidden', {
            'w-16 ml-2': isExpanded,
            'w-0 ml-0': !isExpanded,
          })}
        />
      </div>
      <IconButton
        description='toggle sidebar'
        src={collapseIcon}
        className={tailwindOverride('transition-display mr-1', {
          'inline-flex': isExpanded,
          hidden: !isExpanded,
        })}
        iconClassname={tailwindOverride(
          'items-center	justify-center bg-primary-darker bg-opacity-50 rounded-sm h-4 w-4 text-lg text-off-white'
        )}
        hasASize={false}
        onClick={onToggleExpanded}
        aria-label='toggle sidebar'
        aria-expanded={isExpanded}
        aria-controls='main-nav-content'
      />
    </div>
  );
};

export default Header;
